import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { AppErrorBoundary } from "@/observability/AppErrorBoundary";
import { initSentry, reportRecoverableError } from "@/observability/sentry";
import "./styles/globals.css";

// Initialize Sentry (no-op when VITE_SENTRY_DSN is unset). Runs before the app
// renders so early errors are captured (mirrors backend src/index.ts).
initSentry({ service: "race-manager-frontend" });

ReactDOM.createRoot(document.getElementById("root")!, {
  // Capture errors React swallows while recovering from failed renders;
  // without this they can resurface as misleading downstream crashes.
  onRecoverableError: (error, errorInfo) =>
    reportRecoverableError(error, { componentStack: errorInfo.componentStack }),
}).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
